export default __webpack_public_path__ + "static/media/producer_role_icon.77d23b3b.svg";